var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBiExclamation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0031 16.9997C11.0031 16.8027 11.0419 16.6077 11.1172 16.4257C11.1926 16.2437 11.3031 16.0783 11.4424 15.939C11.5817 15.7997 11.747 15.6893 11.929 15.6139C12.111 15.5385 12.3061 15.4997 12.5031 15.4997C12.7 15.4997 12.8951 15.5385 13.0771 15.6139C13.2591 15.6893 13.4244 15.7997 13.5637 15.939C13.703 16.0783 13.8135 16.2437 13.8889 16.4257C13.9643 16.6077 14.0031 16.8027 14.0031 16.9997C14.0031 17.3975 13.845 17.779 13.5637 18.0603C13.2824 18.3417 12.9009 18.4997 12.5031 18.4997C12.1052 18.4997 11.7237 18.3417 11.4424 18.0603C11.1611 17.779 11.0031 17.3975 11.0031 16.9997ZM11.1501 7.99219C11.1301 7.80295 11.1501 7.61163 11.2089 7.43063C11.2676 7.24963 11.3637 7.08301 11.491 6.94157C11.6183 6.80013 11.7739 6.68703 11.9478 6.60961C12.1216 6.53219 12.3098 6.49219 12.5001 6.49219C12.6903 6.49219 12.8785 6.53219 13.0523 6.60961C13.2262 6.68703 13.3818 6.80013 13.5091 6.94157C13.6364 7.08301 13.7325 7.24963 13.7913 7.43063C13.85 7.61163 13.87 7.80295 13.8501 7.99219L13.3251 13.2527C13.3037 13.4566 13.2076 13.6454 13.0553 13.7827C12.9029 13.9199 12.7051 13.9959 12.5001 13.9959C12.295 13.9959 12.0972 13.9199 11.9449 13.7827C11.7925 13.6454 11.6964 13.4566 11.6751 13.2527L11.1501 7.99219Z",
    fill: "#E93030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiExclamation);
export default __webpack_public_path__ + "static/media/bi_exclamation.0d2b8bb81f02df5412e55314f7a5d398.svg";
export { ForwardRef as ReactComponent };